export default __webpack_public_path__ + "516893ce860a9baafe855248df895c62.svg";